// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  page: {
    name: 'page',
    componentName: 'Page',
    chunk: () => import(
      /* webpackChunkName: "page" */
      './pages/Page'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/Page.js')).Page
        : currentRouteName === 'page'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Page })));
    },
    path: ["/:context?/b/*"],
    channel: null
  },
});
